import { menuselect } from "@/constant/menuselect";

let str = "物资管理";
export const config = {
  title: "智慧供应链管理(SPD)",
  headerInfo:
    "实现医院物资供应的信息化、智能化管理，确保物资供应的高效、准确与及时。通过整合供应商、临床使用科室、物资管理部门及财务部门等资源，构建一体化的管理平台，提升供应链效率，降低运营成本，实现资源的优化配置和医院运营管理的整体提升。",
  headerImg: require("@/assets/images/supplyChain/Rectangle 19header.png"),
  activeTitle: str,
  activeSubTitle: str,

  navList: [
    {
      name: "智慧供应链管理(SPD)",
      children: menuselect(),
    },
    {
      name: "物资管理",
      desc: "为了实现院内外物流的精细化、全程化、可视化管理，需要从采购到付款实现业务流程的重组，物资申领、计划、采购、入库、出库、消耗的全过程透明可控，需要实现对物资批次、效期、序列、货位的有效记录，保证质量与安全，有效降低物资成本。",
      tabList: [{}],
      [str]: [
        {
          title: "",
          desc: " ",
          img: require("@/assets/images/supplyChain/Group 970one.png"),
        },
        {
          title: "重点关注环节",
          desc: " ",
          img: require("@/assets/images/supplyChain/Group 1140one.png"),
        },
        {
          title: "方案特点",
          desc: " ",
          img: require("@/assets/images/supplyChain/Group 994one.png"),
        },
        {
          title: "应用价值",
          desc: " ",
          img: require("@/assets/images/supplyChain/Frame 1143one.png"),
        },
      ],
    },
    {
      name: "高值耗材管理",
      desc: "高值耗材全程基于序列号进行一物一码寄售管理，实际给病人使用计费后再与供应商进行消耗结算。通过HIS系统和HRP系统的稽核扣减，实现高值耗材使用与收入收支配比，并能追踪到患者，实现高值耗材的全程跟踪。",
      tabList: [{}],
      [str]: [
        {
          title: "",
          desc: " ",
          img: require("@/assets/images/supplyChain/Group 999two.png"),
        },
        {
          title: "关键收益",
          desc: " ",
          img: require("@/assets/images/supplyChain/Group 1140two.png"),
        },
      ],
    },
    {
      name: "低值耗材管理",
      desc: "敬在信息根据多个大型医、教、研一体化三甲医院的经验，形成先进的完整的低值耗材管理方案。",
      tabList: [{}],
      [str]: [
        {
          title: "",
          desc: " ",
          img: require("@/assets/images/supplyChain/Group 1004three.png"),
        },
        {
          title: "方案价值",
          desc: " ",
          img: require("@/assets/images/supplyChain/Group 1004three-1.png"),
        },
      ],
    },
    {
      name: "二级库管理",
      desc: "敬在智能二级库管理助手，应用智能、驱动智慧。通过对科室二级库管理，改善科室耗占比统计，成为医院成本控制、资金使用和临床质量安全的关键节点。",
      tabList: [{}],
      [str]: [
        {
          title: "",
          desc: " ",
          img: require("@/assets/images/supplyChain/Group 1022four.png"),
        },
        {
          title: "应用价值",
          desc: "手持终端扫码库存全方位管理 常用一次性耗材业务全线管理 在线管理、实时监控、智能存储 跟台耗材申请计费全流程管理 智能集成RFID、耗材柜等硬件",
        },{
          title: "推进要点",
          desc: "",
          img: require("@/assets/images/supplyChain/Group 1140four.png"),
        },
      ],
    },
    {
      name: "药品管理",
      desc: "直连院外物流系统，提高药品供应效率的同时加强药品资质、效期、采购计划、库存管理，实现对药品的全流程追溯闭环管理、物资精细化管理，为医院打造企业级的现代化物流体系。",
      tabList: [{}],
      [str]: [
        {
          title: "",
          desc: " ",
          img: require("@/assets/images/supplyChain/Frame 1010five.png"),
        },
        {
          title: "应用价值",
          desc:`特点：整合供应链、高效库存管理、提高作业效率、配合专业的物流服务。      价值：科学制定采购计划，药房可基于消耗自动生成需求药库可基于自动补货生成需求;连接供应商,减少订单履约时间;近效期提醒、滞销提醒;库容计算与预警货位精细化管理;药品批号管理保证账实相符;计费(收入)和发药(成本)同比传送。实现收支配比。`,
          img: require("@/assets/images/supplyChain/Frame 1011five.png"),
        },
      ],
    },
    {
      name: "中药饮片溯源平台(TSD+)",
      desc: "TSD+通过融合标准化中药饮片、自动化调剂设备、标准化煎煮服务、临床数据服务和全流程追溯管理体系，实现中药饮片临床使用的自动化和标准化。在科研方面，TSD+项目的推进能够实现中药饮片全流程数据化、数据可证据化、证据可评价化。从原植物的种子种苗鉴定到原药材的采收、加工、炮制，到质量检测、物流和运输，甚至临床使用终端，都需要对其身份与质量进行确认，构建完整的质量追溯系统，以保证用药的安全有效，真正做到药材和饮片的“来源可溯、去向可追、质量可查、责任可究”的管理目标。",
      tabList: [{}],
      [str]: [
        {
          title: "",
          desc: " ",
          img: require("@/assets/images/supplyChain/Group 1029six.png"),
        },
        {
          title: "系统特点及应用价值",
          desc: " ",
          img: require("@/assets/images/supplyChain/Group 1030six.png"),
        },
      ],
    },
    {
      name: "试剂管理",
      desc: "敬在试剂管理系统是从需求、采购、仓储到班组消耗的精细化管理软件。对于内科、外科等检验单元的试剂领用、消耗、库存管理等业务进行条码规范化管理。实现试剂领用消耗与检验样本项目进行配比监控管理，减少试剂管理中的潜在隐患，降低不合理浪费。",
      tabList: [{}],
      [str]: [
        {
          title: "管理流程图",
          desc: " ",
          img: require("@/assets/images/supplyChain/Group 1031seven.png"),
        },
        {
          title: "应用价值",
          desc: " ",
          img: require("@/assets/images/supplyChain/Frame 1143seven.png"),
        },
      ],
    },
    {
      name: "电子采购平台(供应商协同)",
      desc: "敬在蜂采供应协同平台提供采购订单协同、发货协同、发票协同、供应商资质信息协同等供应商与医院的协同功能，有效降低前端医务人员录入工作，提高工作效率。连接医院内部与外部供应商进行在线实时交互，降低协同成本。打造从采购到销售到对账的管理平台，建立高效的供应链协作方式。",
      tabList: [{}],
      [str]: [
        {
          title: "",
          desc: " ",
          img: require("@/assets/images/supplyChain/Group 1037eight.png"),
        },
        {
          title: "",
          desc: " ",
          img: require("@/assets/images/supplyChain/Group 1038eight.png"),
        },
      ],
    },
  ],
};
